import * as React from "react";
import AsyncSelect from "react-select/lib/Async";
import { ValueType } from "react-select/lib/types";

import { HorseForSaleEndpoints } from "../../endpoints/HorseForSaleEndpoints";
import { SimpleHorseForSale, HorseForSaleState } from "../../model/HorseForSale";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGavel } from "@fortawesome/free-solid-svg-icons";

export interface Props {
    horseForSaleEndpoints: HorseForSaleEndpoints;
    isDisabledLink?: boolean;
    style?: string;
    value: SimpleHorseForSale | null | undefined;
    onChange?: (HorseForSale: SimpleHorseForSale | null) => void;
    involvementSaleFilters?: Array<number>;
    involvementStateFilters?: Array<HorseForSaleState>;
    placeholder?: string;
}

export default class HorseForSaleSelect extends React.Component<Props, {}> {
    private latestHorseList: Array<SimpleHorseForSale> = [];
    private mostRecentRequest: number = 1;

    constructor(props: Props) {
        super(props);
    }

    loadOptions = async (fullTextSearch: string) => {
        const requestNo = ++this.mostRecentRequest;
        const horseList = await this.props.horseForSaleEndpoints.getHorseForSaleList(50, 0, undefined, {
            fullTextSearch,
            saleIds: (this.props.involvementSaleFilters || []).join(","),
            states: (this.props.involvementStateFilters || []).join(",")
        });

        if (requestNo !== this.mostRecentRequest) {
            // A newer request has been ordered, this one is no longer relevant :(
            return [];
        }

        this.latestHorseList = horseList.results;

        const options = horseList.results.map(horseForSale => this.horseForSaleToOption(horseForSale));
        return options;
    };

    render() {
        return (
            <AsyncSelect
                isDisabled={this.props.isDisabledLink}
                loadOptions={this.loadOptions}
                cacheOptions={false}
                isClearable={true}
                className={this.props.style}
                value={this.horseForSaleToOption(this.props.value)}
                onChange={(ref: any) => {
                    if (this.props.onChange) {
                        const horse = ref ? this.latestHorseList.find(c => c.id === ref.value) || null : null;
                        this.props.onChange(horse);
                    }
                }}
                placeholder={this.props.placeholder}
            />
        );
    }

    private horseForSaleToOption(horseForSale: SimpleHorseForSale | null | undefined): ValueType<{ label: React.ReactNode; value: number }> {
        if (!horseForSale) {
            return null;
        }

        const label = (
            <div>
                <FontAwesomeIcon icon={faGavel} />
                {horseForSale.hipNumber ? ` #${horseForSale.hipNumber}` : ``}
                &nbsp;{horseForSale.horse.name}
            </div>
        );

        return { label, value: horseForSale.id };
    }
}



// WEBPACK FOOTER //
// ./src/components/common/HorseForSaleSelect.tsx